<template>
  <div style="background-color: transparent;">
    <div class="transparent mt-12">
        <div id="clock" class="" v-bind:class="[foreColor, fontStyle]" v-bind:style="{background: '#'  + colorss, color: '#'  + txcolor}">
          <span class="date" v-bind:class="dateOn">{{ date }}</span>
          <span class="time">{{ time }}</span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      date: "",
      time: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      hide:this.$route.query.hide,
      color: this.$route.query.color,
      fontstyle: this.$route.query.font,
      colors:this.$route.query.colors,
      txcolor:this.$route.query.txcolor,
    };
  },

  computed: {
    colorss: function () {
      return this.$route.query.colors;
    },
    dateOn: function() {
      if (this.hide === 'off') {
        return 'date-off';
      }
      else {
        return '';
      }
    },
    foreColor: function() {
      if (this.color === 'green') {
        return 'green-gradient-background';
      }
      else if (this.color === 'blue') {
        return 'blue-gradient-background';
      }
      else if (this.color === 'red') {
        return 'red-gradient-background';
      }
      else if (this.color === 'sky') {
        return 'sky-gradient-background';
      }
      else if (this.color === 'gray') {
        return 'gray-gradient-background';
      }
      else if (this.color === 'yellow') {
        return 'yellow-gradient-background';
      }
      else if (this.color === 'lush') {
        return 'lush-gradient-background';
      }
      else if (this.color === 'moon') {
        return 'moon-gradient-background';
      }
      else if (this.color === 'rose') {
        return 'rose-gradient-background';
      }
      else if (this.color === 'steel') {
        return 'steel-gradient-background';
      }
      else {
        return '';
      }
    },
    fontStyle: function() {
      if (this.fontstyle === 'font0') {
        return 'font0';
      }
      else if (this.fontstyle === 'font1') {
        return 'font1';
      }
      else if (this.fontstyle === 'font2') {
        return 'font2';
      }
      else if (this.fontstyle === 'font3') {
        return 'font3';
      }
      else if (this.fontstyle === 'font4') {
        return 'font4 font4-manage';
      }
      else if (this.fontstyle === 'font5') {
        return 'font5 font5-manage';
      }
      else {
        return '';
      }
    }
  },
  mounted: function () {
    setInterval(this.updateTime, 1000);
  },
  methods: {
    updateTime: function () {
      //現在の日付・時刻を取得
      let currentdate = new Date();

      // 現在の時刻
      this.time =
        this.zeroPadding(currentdate.getHours(), 2) +
        ":" +
        this.zeroPadding(currentdate.getMinutes(), 2);
      // this.zeroPadding(currentdate.getSeconds(), 2);

      // 現在の年月日
      this.date =
        this.zeroPadding(currentdate.getFullYear(), 4) +
        "-" +
        this.zeroPadding(currentdate.getMonth() + 1, 2) +
        "-" +
        this.zeroPadding(currentdate.getDate(), 2) +
        " " +
        this.week[currentdate.getDay()];
    },
    zeroPadding: function (num, len) {
      let zero = "";

      // 0の文字列を作成
      for (var i = 0; i < len; i++) {
        zero += "0";
      }

      // zeroの文字列と、数字を結合し、後ろ２文字を返す
      return (zero + num).slice(-len);
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Iceland&family=Open+Sans:wght@500&family=Shadows+Into+Light&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Yuji+Mai&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Klee+One:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Single+Day&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Tiny5&display=swap');


p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.content-title{
  text-align: center;
}

h2{
  position: relative;
  display: inline-block;
  padding: 0 65px;
  text-align: center;
  letter-spacing: 1px
}

h2:before,
h2:after {
  position: absolute;
  top: calc(50% - 3px);
  width: 50px;
  height: 6px;
  content: '';
  border-top: solid 2px #000;
  border-bottom: solid 2px #000;
}

h2:before {
  left: 0;
}

h2:after {
  right: 0;
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

.main{
  max-width: 514px;
  margin: 0 auto;
}

#clock {
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 12px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  color: #fff;
}

.time {
  letter-spacing: 0.05em;
  font-size: 80px;
  line-height: 0.9em;
}

.date {
  padding-top: 12px;
  letter-spacing: 0.1em;
  font-size: 24px;
  display: block;
}

.set{
  padding: 8px 12px 24px 12px;
  margin-top: 24px;
  background-color: #f9f3e9;
}

.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.select-font{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  width: 48px;
  padding: 12px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.date-off{
  display:none;
}

.blue-gradient-background {
  background: linear-gradient(260deg,#FBDA61 0%, #FF5ACD 100%);
  background-size: 180% 180%;
  animation: blue-gradient-animation 10s ease infinite;
}

@keyframes blue-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.red-gradient-background {
  background: linear-gradient(43deg,#4158D0 0%, #C850C0 46%, #FFCC70 100%);
  background-size: 180% 180%;
  animation: red-gradient-animation 6s ease infinite;
}

@keyframes red-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.green-gradient-background {
  background: linear-gradient(256deg,#0093E9 0%,#a1efc6 46%, #80D0C7 100%);
  background-size: 240% 240%;
  animation: green-gradient-animation 10s ease infinite;
}

@keyframes green-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.sky-gradient-background {
  background: linear-gradient(260deg, #D9AFD9 0%, #97D9E1 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

@keyframes sky-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.blue-glass-background {
    background: rgba( 39, 208, 251, 0.25 );
    box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 )!important;
    backdrop-filter: blur( 4px )!important;
    -webkit-backdrop-filter: blur( 4px )!important;
    border-radius: 10px;
    border: 1px solid rgba( 255, 255, 255, 0.18 );
}

.red-glass-background {
    background: rgba( 255, 61, 232, 0.25 );
    box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 )!important;
    backdrop-filter: blur( 4px )!important;
    -webkit-backdrop-filter: blur( 4px )!important;
    border-radius: 10px;
    border: 1px solid rgba( 255, 255, 255, 0.18 );
}
.green-glass-background {
    background: rgba( 162, 233, 134, 0.25 );
    box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 );
    backdrop-filter: blur( 4px );
    -webkit-backdrop-filter: blur( 4px );
    border-radius: 10px;
    border: 1px solid rgba( 255, 255, 255, 0.18 );
}

.sky-glass-background {
    background: rgba( 139, 87, 42, 0.25 );
    box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 );
    backdrop-filter: blur( 4px );
    -webkit-backdrop-filter: blur( 4px );
    border-radius: 10px;
    border: 1px solid rgba( 255, 255, 255, 0.18 );
}

.gray-gradient-background {
  background: linear-gradient(260deg, #304352 0%, #d7d2cc 100%);
  background-size: 240% 240%;
  animation: gray-gradient-animation 12s ease infinite;
}

@keyframes gray-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.yellow-gradient-background {
  background: linear-gradient(260deg, #F3F9A7 0%, #CAC531 100%);
  background-size: 240% 240%;
  animation: yellow-gradient-animation 12s ease infinite;
}

@keyframes yellow-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.lush-gradient-background {
  background: linear-gradient(260deg, #56ab2f 0%, #a8e063 100%);
  background-size: 240% 240%;
  animation: lush-gradient-animation 12s ease infinite;
}

@keyframes lush-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.moon-gradient-background {
  background: linear-gradient(260deg, #4e54c8 0%, #8f94fb 100%);
  background-size: 240% 240%;
  animation: moon-gradient-animation 12s ease infinite;
}

@keyframes moon-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.rose-gradient-background {
  background: linear-gradient(260deg, #f4c4f3 0%, #fc67fa 100%);
  background-size: 240% 240%;
  animation: rose-gradient-animation 12s ease infinite;
}

@keyframes rose-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.steel-gradient-background {
  background: linear-gradient(260deg, #1F1C2C 0%, #928DAB 100%);
  background-size: 240% 240%;
  animation: steel-gradient-animation 12s ease infinite;
}

@keyframes steel-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.font0{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

.font1{
  font-family: "Open Sans", sans-serif;
}
.font2{
  font-family: 'Iceland', cursive;
}
.font3{
  font-family: 'Single Day', cursive;
}
.font4{
  font-family: 'Klee One', cursive;
}
.font4-manage{
  padding-bottom: 20px !important;
}
.font5{
  font-family: "Tiny5", serif;
  font-weight: 400;
  font-style: normal;
}
.font5-manage{
  padding-left: 40px !important;
}
.radio-main{
  display: -webkit-flex;
  display: flex;
  margin-top:12px;
}
.m-form-text{
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

</style>